import React from "react";

export const ProductNameContext = React.createContext("Remeet");
